/**
 * @packageDocumentation
 * @module dom/database
 */

import { domQueue, t_task } from '../core/dom_queue';

export interface Write {
  /**
   * A performant method for assigning values to node, in a closure
   *
   * @param fn execute code to alert elements
   */
  (fn: t_task): t_task;
}

/**
 * { @link Write }
 */
export default (fn: t_task) => domQueue.mutate(fn);
